import { RoutalPalette, RoutalText, VSpacer } from '@nx-smartmonkey/ui';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { InputPasswordProps, PasswordInput } from './PasswordInput';

export type PasswordInputWithCapsLockProps = InputPasswordProps;

export const PasswordInputWithCapsLock = ({ ...passwordInputProps }: PasswordInputWithCapsLockProps) => {
  const intl = useIntl();
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [isCapsLock, setIsCapsLock] = useState<boolean>(false);

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === `CapsLock`) {
      setIsCapsLock(!isCapsLock);
    } else {
      if (e.getModifierState(`CapsLock`)) {
        setIsCapsLock(true);
      } else {
        setIsCapsLock(false);
      }
    }

    passwordInputProps.onKeyDown?.(e);
  };

  return (
    <>
      <PasswordInput
        {...passwordInputProps}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onKeyDown={onKeyDown}
        inputContainerStyles={{
          ...passwordInputProps.inputContainerStyles,
          ...(isCapsLock && isFocused ? { marginBottom: undefined } : {}),
        }}
      />
      <VSpacer small />
      <RoutalText
        style={{ color: RoutalPalette.secondary00, visibility: isCapsLock && isFocused ? `visible` : `hidden` }}
      >
        {intl.formatMessage({ id: `password.caps_lock` })}
      </RoutalText>
    </>
  );
};
